import { NonUserEmailsTableProvider } from './NonUserEmailsTableContext'
import { NonUserEmailsTable } from './components/NonUserEmailsTable'

const NonUserEmails: React.FC = () => (
  <NonUserEmailsTableProvider>
    <NonUserEmailsTable />
  </NonUserEmailsTableProvider>
)

export default NonUserEmails
